import '.au{flex-shrink:0;}.ssr-plugin'
import '.a4{padding:1rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.az{height:100%;}.ssr-plugin'
import '.bg{border:none;}.ssr-plugin'
import '.c8{background-color:transparent;}.ssr-plugin'
import '.c9{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.t{align-items:stretch;}.ssr-plugin'
import '.c0{position:sticky;}.ssr-plugin'
import '.ca{top:4rem;}.ssr-plugin'
import '.cb{z-index:7;}.ssr-plugin'
import '.ad{background-color:var(--palette-white);}.ssr-plugin'
import '.cc{padding-bottom:1rem;}.ssr-plugin'
import '.cd{margin-bottom:1rem;}.ssr-plugin'
import '.ce{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.bl{top:0px;}.ssr-plugin'
import '.bm{left:0px;}.ssr-plugin'
import '.bn{right:0px;}.ssr-plugin'
import '.bo{bottom:0px;}.ssr-plugin'
import '.cf{z-index:9999;}.ssr-plugin'
import '.cg{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.c4{justify-content:flex-end;}.ssr-plugin'
import '.b0{flex:1;}.ssr-plugin'
import '.bx{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="au a4 n az bg c8 c9"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e t"
    >
      <div className="c0 ca cb ad cc cd ce d"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="i bl bm bn bo cf ad cg d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="a4 d c4 ce"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="b0 bx">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
